// receipt-urls.ts - 纯函数：合并账目已有小票 URL 与本次新上传的 URL
// 不依赖 Angular / Firebase，供 firebase.service.ts 与单测共用。

export interface EntryReceiptFields {
  receiptUrls?: string[];
  receiptUrl?: string;
}

/**
 * 合并账目已有的小票 URL（兼容旧的单数 receiptUrl 字段）与新上传的 URL 列表。
 * 新 URL 一律追加在已有 URL 之后；不因为新 URL 为空而丢弃已有 URL。
 */
export function mergeReceiptUrls(entry: EntryReceiptFields | null | undefined, newUrls: string[]): string[] {
  const existing = entry?.receiptUrls?.length
    ? entry.receiptUrls
    : (entry?.receiptUrl ? [entry.receiptUrl] : []);
  return [...existing, ...(newUrls || [])];
}
